module.exports = (rate) => {
    return (rate * 100).toFixed(1);
}


// WEBPACK FOOTER //
// ./src/filters/toPercent.js